























































































import { Component, Prop, Vue, Mixins, Ref } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import UserRoleSelect from "@/components/User/RoleSelect.vue";
import { User } from "../../models";
import CompanyFamiliesMixin from "@/mixins/http/CompanyFamiliesMixin";
import FamilySelect from "@/components/Family/Select.vue";
import { showToast } from "../../utils/RailsRoutes";
import ICompanyFamily from "../../models/interfaces/ICompanyFamily";
import { CompanyFamilyPayload } from "../../models/CompanyFamily";
import VPercentInput from "@/components/VPercentInput.vue";
import { NoCache, RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";
import DisplayErrors from "@/components/DisplayErrors.vue";
import DiscountInput from "@/components/CompanyFamily/DiscountInput.vue";

const updateTag = "update_company_family";
const createTag = "create_company_family";

@Component({
  components: {
    VModal,
    DisplayErrors,
    DiscountInput,
    FamilySelect,
    VPercentInput,
    UserRoleSelect,
  },
})
export default class EditCompanyFamily extends Mixins(CompanyFamiliesMixin) {
  item: CompanyFamilyPayload = new CompanyFamilyPayload();
  @Ref() readonly modal!: VModal;
  content = "";
  isNew = false;

  @RegisterHttp(createTag) createRequest?: RequestData;
  @RegisterHttp(updateTag) updateRequest?: RequestData;

  canceled!: Function | null;

  get showPercentage() {
    return this.item.discount || this.item.negotiatingDiscount;
  }

  label(index: number) {
    return `Extra discount ${index + 1}`;
  }

  onFamilySelected(familyId: string) {
    this.item.familyId = familyId;
  }

  get discount() {
    const discounts = [...this.item.additionalDiscounts];
    const percentage =
      1 -
      discounts.reduce(
        (accumulator, discount) => accumulator * (1 - discount),
        1 - this.item.discount
      );

    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `${formatter.format(percentage * 100)}%`;
  }

  get negotiatingDiscountFormatted() {
    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `${formatter.format(this.item.negotiatingDiscount * 100)}%`;
  }

  onChanged(index: number, value: number) {
    Vue.set(this.item.additionalDiscounts, index, value);
  }

  get valid() {
    if (!this.item) {
      return false;
    }
    const editValid =
      this.item.discount != null &&
      this.item.negotiatingDiscount != null &&
      this.item.familyId;

    if (this.isNew) {
      return this.item.companyId && editValid;
    } else {
      return editValid;
    }
  }

  onDestroyDiscount(index: number) {
    this.item.additionalDiscounts.splice(index, 1);
  }

  addDiscount() {
    this.item.additionalDiscounts.push(0);
  }

  title() {
    return `${this.isNew ? "Add" : "Edit"} family`;
  }

  protected onCancel() {
    if (this.canceled) {
      this.canceled();
    }

    this.canceled = null;
    this.modal.hide();
  }

  protected onConfirm() {
    if (this.valid) {
      this.$emit("confirmed", this.item);
      this.modal.hide();
    }
  }

  protected onHidden() {
    this.reset();
    if (this.canceled) {
      this.canceled();
    }
  }

  edit(item: ICompanyFamily) {
    this.isNew = false;
    this.modal.show();
    this.item = CompanyFamilyPayload.fromData(item);
  }

  reset() {
    this.item = null;
  }

  create(companyId: string) {
    this.isNew = true;
    this.modal.show();
    this.item = new CompanyFamilyPayload();
    this.item.companyId = companyId;
  }

  get loading() {
    return this.createRequest?.loading || this.updateRequest?.loading;
  }

  async save() {
    try {
      const resp = this.isNew
        ? await this.createCompanyFamily(this.item, createTag)
        : await this.updateCompanyFamily(this.item, updateTag);
      const emitTag = this.isNew ? "created" : "updated";
      this.$emit(emitTag, resp);
      showToast("Record saved successfully!");
      this.modal.hide();
    } catch (err) {
      showToast("An error occurred while saving the record: " + err, {
        type: "error",
      });
    }
  }
}
